var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AddCamera"},[_c('NewForm',{attrs:{"data":_vm.formData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }